import { render, staticRenderFns } from "./CustomerFollowLog.vue?vue&type=template&id=7f324204&scoped=true"
import script from "./CustomerFollowLog.vue?vue&type=script&lang=js"
export * from "./CustomerFollowLog.vue?vue&type=script&lang=js"
import style0 from "./CustomerFollowLog.vue?vue&type=style&index=0&id=7f324204&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f324204",
  null
  
)

export default component.exports